// extracted by extract-css-chunks-webpack-plugin
module.exports = {"screenReaderOnly":"screenReaderOnly_dUqaW"};